import React, { useEffect, useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { IoChatbubble } from "react-icons/io5";

const FullHistory = ({ orders }) => {
  const [filter, setFilter] = useState("default");
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(8); // adjustable per page

  const filterOrders = (type) => {
    switch (type) {
      case "Paid":
        return orders.filter((order) => order.orderStatus === "paid");
      case "Completed":
        return orders.filter((order) => order.orderStatus === "delivered");
      case "Refunded":
        return orders.filter((order) => order.orderStatus === "refunded");
      default:
        return orders.filter(
          (order) =>
            order.orderStatus === "delivered" ||
            order.orderStatus === "canceled" ||
            order.orderStatus === "refunded"
        );
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "paid":
        return "status-paid";
      case "delivered":
        return "status-complete";
      case "refunded":
        return "status-refunded";
      case "canceled":
        return "status-canceled";
      default:
        return "";
    }
  };

  useEffect(() => {
    setFilteredOrders(filterOrders(filter));
    setCurrentPage(1);
  }, [filter, orders]);

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredOrders.slice(
    indexOfFirstOrder,
    indexOfLastOrder
  );
  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <section className="orders-history-container">
      <div className="orders-header">
        <div>
          <h2>{orders.length}</h2>
          <p>
            <span className="trend-up">↑ 00.00%</span> via last 30 days
          </p>
        </div>
        <div className="filters">
          {["default", "Paid", "Refunded", "Completed"].map((type) => (
            <button
              key={type}
              className={filter === type ? "active" : ""}
              onClick={() => setFilter(type)}
            >
              {type === "default" ? "All orders" : type}
            </button>
          ))}
        </div>
      </div>

      <div className="orders-table">
        <div className="orders-row header">
          <span></span>
          <div>Order</div>
          <div>Date</div>
          <div>Status</div>
          <div>Amount</div>
          <div>Customer</div>
          <div></div>
        </div>

        {currentOrders.length > 0 ? (
          currentOrders.map((order, idx) => (
            <div className="orders-row" key={idx}>
              <div>{order.orderNumber}</div>
              <div>
                <p>{new Date(order.orderAt).toString().split("GMT")[0]}</p>
              </div>
              <div className={getStatusClass(order.orderStatus)}>
                {/* <span className="dot"></span> */}
                {order.orderStatus}
              </div>
              <div>${order.totalAmount}</div>
              <div className="customer-cell">{order.customer.name}</div>
              {/* <div className="actions">
                <span>⋮</span>
              </div> */}
            </div>
          ))
        ) : (
          <p className="no-orders">No past orders available</p>
        )}
      </div>

      {/* Pagination */}
      {filteredOrders.length > ordersPerPage && (
        <div className="pagination">
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <div>
            <button onClick={handlePrevPage} disabled={currentPage === 1}>
              Previous
            </button>
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default FullHistory;
